require('./mortgageRequestSimpleNotePayView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ helpers
const { formatText, getFinalTitle, getLanguage } = require('core/i18n').i18n;
const { md5 } = require('utilities/hash');

// @utilities
const { getEstatesToRequest, shouldGoToEstatesListPage } = require('utilities/mortgageHelper');

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { ContentBox } = require('commonsComponents/contentBox');

// @ components
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestTPVIframe = require('components/mortgageRequest/mortgageRequestTPVIframe/mortgageRequestTPVIframe');
const MortgageRequestPayMarketingCountry = require('components/mortgageRequest/mortgageRequestPayMarketingCountry/mortgageRequestPayMarketingCountry');

// @ constants
const { mortgageTPVIframe } = require('constants/mortgageTPVIframe/mortgageTPVIframe');
const { PAYMENT_AMOUNT_IDENTIFIER } = require('constants/index');

class MortgageRequestSimpleNotePayView extends React.Component {
    constructor(props) {
        super(props);
        shouldGoToEstatesListPage(props.immEstates, props.history);
        this.handleOnCancelAddSimpleNote = this.handleOnCancelAddSimpleNote.bind(this);
    }

    getMappingBreacrumb() {
        const { immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");

        return [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestSimpleNote-title'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);
    }
    handleOnCancelAddSimpleNote(evt) {
        evt.preventDefault();
        this.props.history.push('/myprofile/mortgage/panel');
    }
    handleMerchantOrder(immEstates, mortgageRequestState, summaryDocumentation) {
        const immEstatesList = immEstates.get('list');
        const estatesToRequest = getEstatesToRequest(immEstates, summaryDocumentation);
        const immId = immEstatesList.filter(estate => {
            const shouldKeepElement = estatesToRequest.some((estateToRequest) => {
                return estateToRequest.bienId === estate.get('bienId');
            });
            return shouldKeepElement;
        }).reduce((accumulator, currentValue, index, filteredEstates) => {
            const filteredEstatesSize = filteredEstates.size;
            const itHasOnlyOneItem = filteredEstatesSize === 1;
            const itIsTheLastItem = (filteredEstatesSize - 1) === index;

            if (itHasOnlyOneItem || itIsTheLastItem) {
                accumulator += currentValue.get('bienId');
            } else {
                accumulator += currentValue.get('bienId') + '|';
            }
            return accumulator;
        }, '');
        const expId = mortgageRequestState.get('idExpediente');
        const MERCHANT_ORDER = `NS${expId}_${immId}`;

        return MERCHANT_ORDER;
    }
    handleMerchantAmount(int) {
        const amountIdentifier = getLanguage().toLocaleUpperCase() === 'EN' ? PAYMENT_AMOUNT_IDENTIFIER.EN : PAYMENT_AMOUNT_IDENTIFIER.ES
        if (int.indexOf(amountIdentifier) > 0) {
            let amount = int.split(amountIdentifier);
            int = parseInt(amount[0] + amount[1]);
            return int;
        } else if (parseInt(int) % 1 == 0) {
            int = parseInt(int) + '00'
            return parseInt(int);
        }
    }

    render() {
        const {
            immEstates,
            immFlagBasedFeatures,
            immPayment,
            mortgageRequestState,
            summaryDocumentation,
        } = this.props;
        const estatesToRequest = getEstatesToRequest(immEstates, summaryDocumentation);
        const rawAmount = immPayment.get('simpleNoteCost') * estatesToRequest.length;
        const MERCHANT_ORDER = this.handleMerchantOrder(
            immEstates,
            mortgageRequestState,
            summaryDocumentation
        );
        const MERCHANT_AMOUNT = this.handleMerchantAmount(
            `${MortgageRequestCurrencyHelp({ currency: rawAmount, addCurrencySymbol : true })}`
        );
        const signature = md5(`${mortgageTPVIframe.MERCHANT_MERCHANTCODE}${mortgageTPVIframe.MERCHANT_TERMINAL}${mortgageTPVIframe.OPERATION}${MERCHANT_ORDER}${MERCHANT_AMOUNT}${mortgageTPVIframe.MERCHANT_CURRENCY}${mortgageTPVIframe.PASSWORD}`);

        return (
            <div className="mortgage-request-simple-note-pay-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={this.getMappingBreacrumb()}
                                finalTitle={getFinalTitle('mortgageRequestSimpleNote-title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-offset-2 col-xs-8">
                                <ContentBox>
                                    <div className="mortgage-request-simple-note-pay-view__body-block-1">
                                        <div className="mortgage-request-simple-note-pay-view__body-block-1--street-1">
                                            {formatText('mortgageRequestPay-infoTextNoClient')}
                                        </div>
                                        <div className="mortgage-request-simple-note-pay-view__body-block-1--street-2">
                                            <MortgageRequestTPVIframe
                                                signature={signature}
                                                MERCHANT_ORDER={MERCHANT_ORDER}
                                                MERCHANT_AMOUNT={MERCHANT_AMOUNT}
                                                MERCHANT_MERCHANTCODE={mortgageTPVIframe.MERCHANT_MERCHANTCODE}
                                                MERCHANT_TERMINAL={mortgageTPVIframe.MERCHANT_TERMINAL}
                                                OPERATION={mortgageTPVIframe.OPERATION}
                                                MERCHANT_CURRENCY={mortgageTPVIframe.MERCHANT_CURRENCY}
                                                SECURE={mortgageTPVIframe.SECURE}
                                                immFlagBasedFeatures={immFlagBasedFeatures}
                                            />
                                        </div>
                                    </div>
                                    <hr />
                                    <div className="mortgage-request-simple-note-pay-view__footer">
                                        <div className="col-md-5 col-md-offset-8">
                                            <a href="#" className="ok-link" onClick={this.handleOnCancelAddSimpleNote}>
                                                {formatText('mortgageRequestAppraisalRequest-appraisalRequestReturnToPanel')}
                                            </a>
                                        </div>
                                    </div>
                                </ContentBox>
                                <MortgageRequestPayMarketingCountry />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports.constructor = MortgageRequestSimpleNotePayView;

MortgageRequestSimpleNotePayView.propTypes = {
    history: PropTypes.object.isRequired,
    immEstates: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    mortgageRequestState: PropTypes.object.isRequired,
    summaryDocumentation: PropTypes.object.isRequired
};

module.exports.MortgageRequestSimpleNotePayView = connect(
    state => ({
        immEstates: state.mortgageRequestInmuebles,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immPayment: state.mortgageRequestPayment,
        mortgageRequestState: state.mortgageRequestState,
        summaryDocumentation: state.mortgageRequestSummaryDocumentation,
        immGlobalPosition: state.globalPosition,
    }), null
)(withRouter(MortgageRequestSimpleNotePayView));
